import { queryClient } from "../queryClient";

/**
 * Ends the seller's session in this browser.
 *
 * Used on sign out and whenever the API answers 401. It removes everything the
 * app stored for the signed-in seller (token, user, the bell's seen count, ...)
 * but keeps the choices that belong to the browser, not the account: the
 * light / dark theme and the pinned sidebar. localStorage.clear() used to wipe
 * those too, so every expired session reset the seller's theme.
 *
 * It also empties the data cache: see clearAccountData().
 */
const KEEP = ["app-theme", "sidebar-pinned"];

export function clearSession() {
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) keys.push(localStorage.key(i));
    keys.filter((k) => k && !KEEP.includes(k)).forEach((k) => localStorage.removeItem(k));
  } catch {
    // Storage blocked (private mode, disabled site data): nothing to clear.
  }
  clearAccountData();
}

/**
 * Forget every server answer held for the account that was signed in.
 *
 * The React Query cache lives for as long as the tab, and its keys are not
 * per account ("orders-list", "dashboard-stats"...). Without this, the next
 * seller to sign in on the same tab saw the previous seller's orders, wallet
 * and stores until each refetch landed (pipeline audit P1-01, P2-03). Called on
 * sign out and before a new sign-in writes its token.
 */
export function clearAccountData() {
  queryClient.clear();
}
